/*
 * drawer-builder-tiletweak.js
 * --------------------------------------------------------------------------
 * Live DEBUG + TWEAK canvas for the product-tile grid. Lets us see the real
 * computed layout in both collapsed and expanded states, and tweak columns /
 * gap / padding live on the actual page (real containers, real CSS) — then
 * read off the values to bake in.
 *
 * SAFE BY DEFAULT: dormant unless ?tiletweak=1. Self-contained, removable.
 * Activate:   ?tiletweak=1     Deactivate: ?tiletweak=0
 * --------------------------------------------------------------------------
 */
(function () {
  'use strict';
  var FLAG = 'md-tiletweak';
  // Sheet-band breakpoint for the exported CSS (MD_CONST + literal fallback per
  // the constants contract) so the exported rules land in the same max-width
  // band as drawer-builder.css.
  var MOBILE_MAX = (window.MD_CONST && window.MD_CONST.MOBILE_BREAKPOINT) || 999;

  // URL-param only — the panel no longer persists, so a normal open never shows
  // it. Wipe any activation flag persisted by older versions (keep saved values).
  try { localStorage.removeItem(FLAG); } catch (e) {}
  var p = new URLSearchParams(location.search);
  var paramOn = p.has('tiletweak') && !/^(0|off|false)$/i.test(p.get('tiletweak') || '');
  function isOn() { return paramOn; }
  function ready(fn) { document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', fn) : fn(); }

  // Tweak state, persisted so values survive reloads while dialling in.
  var DEF = { collapsed: { cols: 3, gap: 10, pad: 12 }, expanded: { cols: 3, gap: 10, pad: 12 } };
  var st;
  try { st = JSON.parse(localStorage.getItem(FLAG + '-vals')) || DEF; } catch (e) { st = DEF; }
  function save() { try { localStorage.setItem(FLAG + '-vals', JSON.stringify(st)); } catch (e) {} }

  function listEl() {
    return document.querySelector('#product-show') ||
           document.querySelector('.sidebar-products ul.products');
  }
  function firstTile() {
    var l = listEl(); return l ? l.querySelector('li.list-view-item, li') : null;
  }

  var styleEl, panel;

  function buildOverrideCSS() {
    function block(scope, s) {
      // High specificity (html + body + IDs) + later source order so it beats
      // the existing !important mobile rules.
      return ''
        + 'html body.drawer-builder' + scope + ' #builder-products ul#product-show.products,'
        + 'html body.drawer-builder' + scope + ' .drawer-parent-wrapper .sidebar-products ul.products{'
        +   'display:grid !important;grid-template-columns:repeat(' + s.cols + ',minmax(0,1fr)) !important;'
        +   'gap:' + s.gap + 'px !important;padding:0 ' + s.pad + 'px ' + s.pad + 'px !important;'
        +   'justify-content:stretch !important;}'
        + 'html body.drawer-builder' + scope + ' #builder-products ul#product-show.products>li,'
        + 'html body.drawer-builder' + scope + ' #builder-products ul#product-show.products>li.list-view-item,'
        + 'html body.drawer-builder' + scope + ' .drawer-parent-wrapper .sidebar-products ul.products>li.list-view-item{'
        +   'width:auto !important;max-width:none !important;min-width:0 !important;flex:initial !important;'
        +   'margin:0 !important;justify-self:stretch !important;}';
    }
    // collapsed = no extra state class; expanded = .products-expanded
    return block('', st.collapsed) + block('.products-expanded', st.expanded);
  }
  function applyOverride() { styleEl.textContent = buildOverrideCSS(); save(); render(); }

  function measure() {
    var l = listEl(), t = firstTile();
    if (!l) return null;
    var cs = getComputedStyle(l);
    var cols = (cs.gridTemplateColumns || '').split(' ').filter(Boolean);
    var tr = t ? t.getBoundingClientRect() : null;
    var par = l.parentElement, pcs = par ? getComputedStyle(par) : null;
    var gpar = par && par.parentElement ? par.parentElement : null;
    return {
      display: cs.display,
      ncols: cols.length,
      gap: cs.gap,
      padL: cs.paddingLeft, padR: cs.paddingRight,
      listW: Math.round(l.getBoundingClientRect().width),
      tileW: tr ? Math.round(tr.width) : 0,
      tileH: tr ? Math.round(tr.height) : 0,
      parTag: par ? (par.tagName.toLowerCase() + (par.id ? '#' + par.id : '')) : '—',
      parW: par ? Math.round(par.getBoundingClientRect().width) : 0,
      parPad: pcs ? (parseInt(pcs.paddingLeft) + parseInt(pcs.paddingRight)) : 0,
      gparTag: gpar ? (gpar.tagName.toLowerCase() + (gpar.className ? '.' + String(gpar.className).split(' ')[0] : '')) : '—',
      gparW: gpar ? Math.round(gpar.getBoundingClientRect().width) : 0
    };
  }

  var snaps = { collapsed: null, expanded: null };

  function fmt(m, key) {
    if (!m) return '   —';
    return ('     ' + m[key]).slice(-7);
  }
  function readout() {
    var l = listEl();
    if (!l) return 'product list not found';
    var stateNow = document.body.classList.contains('products-expanded') ? 'expanded' : 'collapsed';
    snaps[stateNow] = measure();
    var c = snaps.collapsed, e = snaps.expanded;
    var rows = [
      ['', '  COLLAPSE', ' EXPANDED'],
      ['cols', 'ncols'], ['tile w', 'tileW'], ['tile h', 'tileH'],
      ['list w', 'listW'], ['gap', 'gap'], ['pad L', 'padL'],
      ['parent', 'parTag'], ['parent w', 'parW'], ['grandpar', 'gparTag'], ['grandpr w', 'gparW']
    ];
    var out = 'NOW: ' + stateNow.toUpperCase() + '   (toggle once to fill both cols)\n';
    rows.forEach(function (r) {
      if (r.length === 3) { out += (r[0] + '          ').slice(0, 10) + r[1] + r[2] + '\n'; return; }
      out += (r[0] + '          ').slice(0, 10) + fmt(c, r[1]) + ' ' + fmt(e, r[1]) + '\n';
    });
    return out;
  }

  function exportCSS() {
    return '/* collapsed */\n'
      + '@media (max-width:' + MOBILE_MAX + 'px){\n'
      + ' body.drawer-builder #builder-products ul#product-show.products{grid-template-columns:repeat(' + st.collapsed.cols + ',minmax(0,1fr))!important;gap:' + st.collapsed.gap + 'px!important;padding:0 ' + st.collapsed.pad + 'px ' + st.collapsed.pad + 'px!important;}\n'
      + ' body.drawer-builder.products-expanded #builder-products ul#product-show.products{grid-template-columns:repeat(' + st.expanded.cols + ',minmax(0,1fr))!important;gap:' + st.expanded.gap + 'px!important;padding:0 ' + st.expanded.pad + 'px ' + st.expanded.pad + 'px!important;}\n'
      + ' body.drawer-builder.products-expanded #builder-products ul#product-show.products>li.list-view-item{width:auto!important;max-width:none!important;flex:initial!important;}\n'
      + '}';
  }

  function row(label, key, prop, min, max) {
    return '<div class="tw-row"><label>' + label + '</label>'
      + '<input type="range" min="' + min + '" max="' + max + '" data-k="' + key + '" data-p="' + prop + '" value="' + st[key][prop] + '">'
      + '<span class="tw-val" data-v="' + key + '.' + prop + '">' + st[key][prop] + '</span></div>';
  }

  function render() {
    if (!panel) return;
    panel.querySelector('[data-readout]').textContent = readout();
    panel.querySelectorAll('.tw-val').forEach(function (s) {
      var ref = s.getAttribute('data-v').split('.'); s.textContent = st[ref[0]][ref[1]];
    });
    panel.querySelector('[data-export]').value = exportCSS();
  }

  function injectStyles() {
    var css = ''
      + '#md-tiletweak{position:fixed;left:8px;right:8px;bottom:8px;z-index:2147483600;background:rgba(17,19,23,.96);color:#fff;'
        + 'font:12px/1.35 ui-monospace,Menlo,monospace;border-radius:12px;box-shadow:0 8px 30px rgba(0,0,0,.5);padding:10px 12px;max-height:74vh;overflow:auto;}'
      + '#md-tiletweak h4{margin:0 0 6px;font-size:12px;letter-spacing:.05em;color:#ffd60a;display:flex;justify-content:space-between;align-items:center;}'
      + '#md-tiletweak pre{margin:0 0 8px;padding:8px;background:#000;border-radius:6px;white-space:pre-wrap;color:#9ff;}'
      + '#md-tiletweak .tw-grp{border-top:1px solid #333;padding-top:6px;margin-top:6px;}'
      + '#md-tiletweak .tw-grp b{color:#7fd1ff;}'
      + '#md-tiletweak .tw-row{display:flex;align-items:center;gap:8px;margin:4px 0;}'
      + '#md-tiletweak .tw-row label{flex:0 0 64px;}'
      + '#md-tiletweak .tw-row input[type=range]{flex:1;}'
      + '#md-tiletweak .tw-val{flex:0 0 32px;text-align:right;color:#fff;font-weight:700;}'
      + '#md-tiletweak textarea{width:100%;height:90px;background:#000;color:#9f9;border:1px solid #333;border-radius:6px;font:11px/1.3 ui-monospace,Menlo,monospace;margin-top:6px;}'
      + '#md-tiletweak button{background:#3a3af5;color:#fff;border:0;border-radius:6px;padding:5px 10px;font:700 12px ui-monospace;cursor:pointer;}'
      + '#md-tiletweak .tw-x{background:#444;}';
    var s = document.createElement('style'); s.id = 'md-tiletweak-style'; s.textContent = css;
    document.head.appendChild(s);
  }

  function build() {
    injectStyles();
    styleEl = document.createElement('style'); styleEl.id = 'md-tiletweak-override';
    document.head.appendChild(styleEl);

    panel = document.createElement('div');
    panel.id = 'md-tiletweak';
    panel.innerHTML =
        '<h4>TILE TWEAK <button class="tw-x" data-close>hide</button></h4>'
      + '<pre data-readout></pre>'
      + '<div class="tw-grp"><b>Collapsed</b>'
      +   row('columns', 'collapsed', 'cols', 1, 6)
      +   row('gap', 'collapsed', 'gap', 0, 24)
      +   row('side pad', 'collapsed', 'pad', 0, 24)
      + '</div>'
      + '<div class="tw-grp"><b>Expanded</b>'
      +   row('columns', 'expanded', 'cols', 1, 6)
      +   row('gap', 'expanded', 'gap', 0, 24)
      +   row('side pad', 'expanded', 'pad', 0, 24)
      + '</div>'
      + '<div class="tw-grp"><b>CSS to bake in</b><textarea data-export readonly></textarea></div>';
    document.body.appendChild(panel);

    panel.addEventListener('input', function (e) {
      var inp = e.target;
      if (inp.type !== 'range') return;
      st[inp.getAttribute('data-k')][inp.getAttribute('data-p')] = parseInt(inp.value, 10);
      applyOverride();
    });
    panel.querySelector('[data-close]').addEventListener('click', function () {
      panel.style.display = panel.style.display === 'none' ? '' : 'none';
    });

    // keep readout fresh when expanding/collapsing
    new MutationObserver(render).observe(document.body, { attributes: true, attributeFilter: ['class'] });
    window.addEventListener('resize', render);

    applyOverride();
  }

  ready(function () {
    if (!isOn()) return;
    if (!document.body.classList.contains('drawer-builder')) return;
    build();
  });
})();
